import { faEllipsisH, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, ClickAwayListener, createStyles, makeStyles, Modal, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { ActionButtonType } from 'components/UI/ActionsPopup/ActionButton';
import { ActionsPopup } from 'components/UI/ActionsPopup/ActionsPopup';
import { FunctionComponent, PropsWithChildren, useState } from 'react';
import { ToolbarOption } from './ToolbarButton';

export interface MobileToolbarButtonProps extends PropsWithChildren {
    disabled?: boolean;
    className?: string;
    options: Array<ToolbarOption>;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        icon: {
            cursor: 'pointer'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    })
);

export const MobileToolbarButton: FunctionComponent<MobileToolbarButtonProps> = props => {
    const classes = useStyles();

    const [show, setShow] = useState(false);

    const listView = (
        <Modal
            open={true}
            aria-labelledby="simple-dialog-title"
            className={classes.modal}
        >
            <ActionsPopup
                actions={props.options}
                onClose={() => setShow(false)}
            />
        </Modal>
    );

    return (
        <>
            <ClickAwayListener onClickAway={() => setShow(false)}>
                <Box
                    onClick={() => !props.disabled && setShow(prev => !prev)}
                    className={clsx(classes.icon, props.className)}
                >
                    {show ? (
                        <FontAwesomeIcon
                            color="#92B4A7"
                            icon={faEllipsisV}
                        />
                    ) : (
                        <FontAwesomeIcon
                            color="#000000"
                            icon={faEllipsisH}
                        />
                    )}
                </Box>
            </ClickAwayListener>
            {show && listView}
        </>
    );
};

export default MobileToolbarButton;
